<template>
    <div class="jobXq">
        <img style="width: 100%;" src="../../assets/images/zp.jpg"/>
        <div style="width: 1290px;margin: 40px auto;border-radius: 6px;border: 1px solid #f1f1f1;">
            <div class="title">招聘公告</div>
            <template v-for="item in list">
                <div class="zp-title">{{item.title}}{{item.num}}人</div>
                <div class="zp-zw">岗位职责：</div>
                <div class="zp-zw-div" v-html="item.jobDesc">

                </div>
                <div class="zp-zw">任职要求：</div>
                <div class="zp-zw-div" v-html="item.detail"></div>
            </template>
        </div>

    </div>
</template>

<script>
    import {getJobList} from '../../api/job.js'

    export default {
        data() {
            return {
                list: [],
            }
        },
        methods: {
            getList() {
                getJobList().then(res => {
                    this.list = res.data
                })
            }
        },
        created() {
            this.getList()
        }
    }
</script>

<style>
    .jobXq {
        width: 100%;
        padding-top: 70px;
    }

    .jobXq .title {
        width: 1200px;
        margin: 45px;
        background-image: url(../../assets/images/6368333439648366199629508.jpg) !important;
        background-size: 100% 50%;
        background-repeat: no-repeat !important;
        background-position: 100% !important;
        height: 30px !important;
        text-align: left;
        padding-bottom: 3px;
        padding-left: 20px;
        color: rgb(36, 113, 206);
        font-family: null;
        font-weight: bold;
        font-size: 16px;
        display: flex;
        align-items: center;
    }

    .zp-title {
        font-family: 微软雅黑;
        font-size: 24px;
        font-weight: bold;
        width: 100%;
        text-align: left;
        margin-left: 45px;
    }

    .zp-zw {
        width: 100%;
        text-align: left;
        margin-left: 45px;
        font-size: 20px;
        margin-top: 20px;
    }

    .zp-zw-p {
        width: 90%;
        text-align: left;
        margin-left: 45px;
        font-size: 16px;
        margin-top: 20px;
    }

    .zp-zw-div {
        width: 90%;
        text-align: left;
        margin-left: 45px;
        margin-top: 20px;
    }
</style>